var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"staffLogin",on:{"click":_vm.toJNJUser}},[_vm._v("强生员工登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }